/* Swiper Global Setup - Ensure Swiper is available globally for v11 */
(function() {
    if (typeof Swiper !== "undefined") {
        console.debug("Swiper v11 bundle loaded successfully");
        console.debug("Swiper version:", Swiper.version || "unknown");
        window.Swiper = Swiper;
        console.debug("Swiper object keys:", Object.keys(Swiper));
        console.debug("Swiper is ready for use in components");
    } else {
        console.error("Swiper not found - check if swiper-bundle.min.js loaded correctly");
    }
})();
